<template>
  <div class="box">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <template v-for="(item, i) in fireTipData">
        <el-tab-pane :key="i" :label="item.title" :name="i + ''"> -->
          <fourth-floor />
          <!-- <third-floor v-else  /> -->
        <!-- </el-tab-pane>
      </template>
    </el-tabs> -->
  </div>
</template>

<script>
// import ThirdFloor from './component/ThirdFloor'
import FourthFloor from './component/FourthFloor'
export default {
  components: {
    FourthFloor
  },
  data() {
    return {
      activeName: '0',
      fireTipData: [
        {
          title: '1#消防报警'
        },
        // {
        //   title: '2#消防报警'
        // },
        // {
        //   title: '3#消防报警'
        // },
        // {
        //   title: '4#消防报警'
        // },
        // {
        //   title: '5#消防报警'
        // },
        // {
        //   title: '6#消防报警'
        // },
        // {
        //   title: '7#消防报警'
        // },
        // {
        //   title: '8#消防报警'
        // },
        // {
        //   title: '9#消防报警'
        // },
        // {
        //   title: '10#消防报警'
        // }
      ]
    };
  },
  created() {
    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
    }
    // const main = document.querySelector('.app-main')
    // const html = document.querySelector('html')
    // main.style.overflowY = 'auto'
    // html.style.overflowY = 'hidden'

  },
  beforeDestroy() {
    // const main = document.querySelector('.app-main')
    // const html = document.querySelector('html')
    // html.style.overflowY = 'auto'
    // main.style.overflowY = 'hidden'
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  margin: 20px;
  padding: 20px 20px 0;
  overflow: auto;
  background-color: #fff;
  width: 1684px;
  height: 1010px;
  overflow: hidden;
}
</style>